'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import KPIBentoGrid from './KPIBentoGrid';
import VisitsChart from './VisitsChart';
import MatchesByZoneChart from './MatchesByZoneChart';
import TopMatchesTable from './TopMatchesTable';
import ActivityFeed from './ActivityFeed';
import AlertCards from './AlertCards';
import { useAuth } from '@/contexts/AuthContext';

export default function DashboardContent() {
  const [dateRange, setDateRange] = useState('7j');
  const { userProfile } = useAuth();

  const displayName = userProfile?.prenom
    ? userProfile?.prenom
    : userProfile?.nom
    ? userProfile?.nom
    : 'Admin';

  return (
    <div className="px-6 lg:px-8 xl:px-10 py-7 max-w-screen-2xl mx-auto">

      {/* Page header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-7">
        <div>
          <h1 className="text-2xl font-700 text-slate-900">Tableau de bord</h1>
          <p className="text-sm text-slate-500 mt-0.5">
            Bonjour, {displayName} 👋
          </p>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex bg-slate-100 rounded-lg p-1">
            {['7j', '30j', '90j']?.map(r => (
              <button
                key={r}
                onClick={() => setDateRange(r)}
                className={`px-3 py-1.5 text-xs font-600 rounded-md transition-all duration-150 ${
                  dateRange === r
                    ? 'bg-white text-slate-900 shadow-sm'
                    : 'text-slate-500 hover:text-slate-700'
                }`}
              >
                {r}
              </button>
            ))}
          </div>
          <Link
            href="/locaux/nouveau"
            className="flex items-center gap-2 px-4 py-2 bg-navy-700 text-white text-sm font-600 rounded-lg hover:bg-navy-800 active:scale-95 transition-all duration-150"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Ajouter un local
          </Link>
        </div>
      </div>
      {/* Alert cards */}
      <AlertCards />
      {/* KPI Bento Grid */}
      <KPIBentoGrid />
      {/* Charts row */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 mt-5">
        <div className="xl:col-span-2">
          <VisitsChart dateRange={dateRange} />
        </div>
        <div className="xl:col-span-1">
          <MatchesByZoneChart />
        </div>
      </div>
      {/* Bottom section */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 mt-5">
        <div className="xl:col-span-2">
          <TopMatchesTable />
        </div>
        <div className="xl:col-span-1">
          <ActivityFeed />
        </div>
      </div>
    </div>
  );
}